import React from "react";
import {useDispatch} from "react-redux";
import PropTypes from "prop-types";

const FieldExButton = ({dataItem, fieldInfo, value, rowIndex, ...props}) => {

    const dispatch = useDispatch();
    const title = fieldInfo?.EditorInfo?.enumList?.find(i => value != null && i.DBValue === value.toString())?.ENValue;
    const updateValue = fieldInfo?.EditorInfo?.enumList?.find(i => value != null && i.DBValue !== value.toString())?.DBValue;

    const clickHandler = async () => {
        if (dataItem) {
            const rowInEditIndex = dataItem.rowInEditIndex;
            dispatch(dataItem.beginEdit(rowIndex));
            await dispatch(dataItem.setField(rowIndex, fieldInfo.Name, updateValue))
            await dispatch(dataItem.save(rowIndex));
            if (rowInEditIndex >= 0) {
                dispatch(dataItem.beginEdit(rowInEditIndex));
            }
        }
    }

    if (title) {
        return (
            <button onClick={clickHandler} className={"btn btn-regular"}>{title}</button>
        );
    }
    return null;
}

FieldExButton.propTypes = {
    fieldInfo: PropTypes.object.isRequired,
    dataItem: PropTypes.object.isRequired,
    value: PropTypes.any.isRequired,
    rowIndex: PropTypes.number.isRequired,
}

export default FieldExButton;